export var CardNetwork;
(function (CardNetwork) {
    CardNetwork["Visa"] = "VISA";
    CardNetwork["Mastercard"] = "MASTERCARD";
    CardNetwork["Jcb"] = "JCB";
    CardNetwork["Amex"] = "AMEX";
    CardNetwork["UnionPay"] = "UNIONPAY";
    /** The user chose no network mark; never auto-detected over. */
    CardNetwork["None"] = "NONE";
})(CardNetwork || (CardNetwork = {}));
//# sourceMappingURL=card-network.enum.js.map